module.exports = __webpack_public_path__ + "img/ir.58d410a2.svg";